import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckCircleIcon } from 'lucide-react';
const trustSignals = ['Instant digital access', 'Secure checkout', 'Join 10,000+ happy parents'];
export function FinalCTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="pricing" ref={ref} className="w-full py-24 px-4 bg-gradient-to-b from-cream to-sage/10" data-id="element-15">
      <div className="max-w-4xl mx-auto text-center" data-id="element-16">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-charcoal mb-6" data-id="element-17">
          No Cry-It-Out. No Guilt. Just Science.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-xl md:text-2xl text-charcoal/70 mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-18">
          You don't have to listen to your baby scream to get your sleep back.
          You just have to speak their biological language.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="flex items-center justify-center gap-4 mb-8" data-id="element-19">
          <div className="flex items-center gap-3" data-id="element-20">
            <span className="text-3xl md:text-4xl text-charcoal/40 line-through font-semibold" data-id="element-21">
              $19.99
            </span>
            <span className="text-5xl md:text-6xl font-bold text-green-600" data-id="element-22">
              $6.39
            </span>
          </div>
          <motion.div initial={{
          scale: 0.8,
          opacity: 0
        }} animate={isInView ? {
          scale: 1,
          opacity: 1
        } : {
          scale: 0.8,
          opacity: 0
        }} transition={{
          duration: 0.5,
          delay: 0.5,
          type: 'spring',
          bounce: 0.4
        }} className="bg-green-600 text-white px-4 py-2 rounded-full font-bold text-lg md:text-xl shadow-lg" data-id="element-23">
            68% OFF
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mb-12" data-id="element-24">
          <CTAButton size="large" data-id="element-25">Get The Reset Guide Now</CTAButton>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto" data-id="element-26">
          {trustSignals.map(signal => <div key={signal} className="flex items-center justify-center space-x-2 text-charcoal/70" data-id="element-27">
              <CheckCircleIcon className="w-5 h-5 text-sage flex-shrink-0" aria-hidden="true" data-id="element-28" />
              <span className="text-sm md:text-base" data-id="element-29">{signal}</span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}